const constructor = {
  name: {
    label: "Nom",
    invalid: {}
  },
};

export default constructor;
